import { getCallable } from "../../../_sdk/client";
import { apiName, endpoints } from "./endpoints";
import type {
    CancelSubscriptionRequest, CancelSubscriptionResponse,
    EndTrialOnSubscriptionRequest, EndTrialOnSubscriptionResponse,
    FinalizeUpdateSubscriptionQuantityRequest, FinalizeUpdateSubscriptionQuantityResponse,
    ReactivateSubscriptionRequest, ReactivateSubscriptionResponse,
    SwitchSubscriptionBillingIntervalRequest, SwitchSubscriptionBillingIntervalResponse,
    UpdateSubscriptionQuantityRequest, UpdateSubscriptionQuantityResponse
} from "./types";

export { apiName };

const cancelSubscription = getCallable<CancelSubscriptionRequest, CancelSubscriptionResponse>(
    apiName,
    "cancelSubscription",
    {
        ...endpoints.cancelSubscription,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/billing/subscriptions/cancel`,
                options: {
                    method: "POST"
                }
            };
        }
    });

const reactivateSubscription = getCallable<ReactivateSubscriptionRequest, ReactivateSubscriptionResponse>(
    apiName,
    "reactivateSubscription",
    {
        ...endpoints.reactivateSubscription,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/billing/subscriptions/reactivate`,
                options: {
                    method: "POST"
                }
            };
        }
    });

const switchSubscriptionBillingInterval = getCallable<SwitchSubscriptionBillingIntervalRequest, SwitchSubscriptionBillingIntervalResponse>(
    apiName,
    "switchSubscriptionBillingInterval",
    {
        ...endpoints.switchSubscriptionBillingInterval,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/billing/subscriptions/interval`,
                options: {
                    method: "POST",
                    body: JSON.stringify(request)
                }
            };
        }
    });

const endTrialOnSubscription = getCallable<EndTrialOnSubscriptionRequest, EndTrialOnSubscriptionResponse>(
    apiName,
    "endTrialOnSubscription",
    {
        ...endpoints.endTrialOnSubscription,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/billing/subscriptions/end-trial`,
                options: {
                    method: "POST"
                }
            };
        }
    });

const updateSubscriptionQuantity = getCallable<UpdateSubscriptionQuantityRequest, UpdateSubscriptionQuantityResponse>(
    apiName,
    "updateSubscriptionQuantity",
    {
        ...endpoints.updateSubscriptionQuantity,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/billing/subscriptions/quantity`,
                options: {
                    method: "POST",
                    body: JSON.stringify(request)
                }
            };
        }
    });

const finalizeUpdateSubscriptionQuantity = getCallable<FinalizeUpdateSubscriptionQuantityRequest, FinalizeUpdateSubscriptionQuantityResponse>(
    apiName,
    "finalizeUpdateSubscriptionQuantity",
    {
        ...endpoints.finalizeUpdateSubscriptionQuantity,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/billing/subscriptions/quantity-finalize`,
                options: {
                    method: "POST",
                    body: JSON.stringify(request)
                }
            };
        }
    });

export const callables = {
    cancelSubscription,
    reactivateSubscription,
    switchSubscriptionBillingInterval,
    endTrialOnSubscription,
    updateSubscriptionQuantity,
    finalizeUpdateSubscriptionQuantity
};
